import { type ReactNode } from 'react';
import { Text } from '@direct-frontend/components';
import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const getPromoactionApplicabilityTypeText = (promoaction: DeepPartial<PromoactionModel>): ReactNode => {
    if (promoaction.applicability?.type === 'CATEGORIES_AND_COLLECTIONS') {
        return 'На выбранные категории и коллекции';
    }

    if (promoaction.applicability?.type === 'PRODUCT_LIST') {
        if (promoaction.meta?.statusColor === 'error') {
            return (
                <Text size="s" color="red">
                    При загрузке товаров из файла произошла ошибка. Откройте страницу редактирования акции, чтобы
                    посмотреть подробности.
                </Text>
            );
        }

        return 'На выбранные товары';
    }

    return 'Без ограничений';
};
